import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CheckCircle2Icon, GiftIcon } from 'lucide-react';
import { PreviewCarousel } from './PreviewCarousel';
import { bonuses, volumes } from '../data/offer';
import type { Volume } from '../types/content';
// 5 volumes share the existing 4 accent tokens; volume 05 reuses primary.
const accentStyles: Record<Volume['accent'], {
  border: string;
  text: string;
}> = {
  info: {
    border: 'border-info/30',
    text: 'text-info'
  },
  primary: {
    border: 'border-primary-soft/30',
    text: 'text-primary-soft'
  },
  highlight: {
    border: 'border-highlight/30',
    text: 'text-highlight'
  },
  danger: {
    border: 'border-danger-soft/30',
    text: 'text-danger-soft'
  }
};
export function ProductOffer() {
  return <>
      <section className="bg-surface px-4 py-16 sm:py-24" data-id="element-147" data-mp="fin1hk1e57in">
        <div className="mx-auto max-w-5xl" data-id="element-148" data-mp="fl82k6tv7jfc">
          <header className="text-center" data-id="element-149" data-mp="kihpnfts7j00">
            <h2 className="font-display text-3xl font-bold text-highlight sm:text-5xl" data-id="element-150" data-mp="khgcn5t7gmfn">
              KIT SIMPLIFICACIÓN INTEGRAL™
            </h2>
            <p className="mx-auto mt-4 max-w-4xl text-lg font-medium" data-id="element-151" data-mp="3gghvfuqgjpfg">
              Un sistema de 5 volúmenes para organizar tus espacios, simplificar tus rutinas y comprar con criterio.
            </p>
          </header>
          <h3 className="mt-12 text-center font-display text-2xl font-bold" data-id="element-152" data-mp="3qf7brj2ph1tl">
            📚 5 VOLÚMENES COMPLETOS
          </h3>
          <div className="mt-7 space-y-5" data-id="element-153" data-mp="32otn82jbxl3r">
            {volumes.map((volume, index) => {
            const accent = accentStyles[volume.accent];
            return <motion.article key={volume.title} initial={{
              opacity: 0,
              y: 16
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.06
            }} className={`flex gap-5 rounded-2xl border ${accent.border} bg-canvas p-5 sm:p-7`} data-id="element-154" data-mp="3bh58l9zl6icv" data-mpi={index}>
                  <BookOpenIcon className={`mt-1 h-7 w-7 shrink-0 ${accent.text}`} aria-hidden="true" data-id="element-155" data-mp="hz4s7xoqgg9w" />
                  <div className="flex-1" data-id="element-156" data-mp="mwo4wt5s8kzq">
                    <p className={`text-xs font-bold tracking-brand ${accent.text}`} data-id="element-157" data-mp="mvd1wvk5vh9o">
                      {volume.label}
                    </p>
                    <h4 className="mt-1 font-display text-lg font-bold sm:text-xl" data-id="element-158" data-mp="wnsn01qr8lys">
                      {volume.title}
                    </h4>
                    <p className="mt-1 text-sm text-foreground-subtle sm:text-base" data-id="element-159" data-mp="3v6pp5u8iah3d">
                      {volume.subtitle}
                    </p>
                    <ul className="mt-4 space-y-2" data-id="element-160" data-mp="8x59n0y2l44u">
                      {volume.items.map(item => <li key={item} className="flex gap-2 text-sm leading-relaxed text-foreground-muted sm:text-base" data-id="element-161" data-mp="dwrofetjqsfr">
                          <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-primary-soft" aria-hidden="true" data-id="element-162" data-mp="1kdmvy87ydqdr" />
                          {item}
                        </li>)}
                    </ul>
                    <p className="mt-5 border-t border-foreground/10 pt-4 text-sm sm:text-base" data-id="element-163" data-mp="39u8q4evhbwz9">
                      <span className="font-semibold text-foreground-subtle" data-id="element-164" data-mp="34umci4bqoepx">Resultado: </span>
                      <span className={`font-bold italic ${accent.text}`} data-id="element-165" data-mp="303e152qumja4">{volume.result}</span>
                    </p>
                  </div>
                </motion.article>;
          })}
          </div>
        </div>
      </section>
      <PreviewCarousel data-id="element-166" data-mp="2q6rkyr9gwgef" />
      <section className="bg-canvas px-4 py-16 sm:py-24" data-id="element-167" data-mp="2q3vkav68jdma">
        <div className="mx-auto max-w-5xl" data-id="element-168" data-mp="2m3blln60k1y1">
          <header className="text-center" data-id="element-169" data-mp="2m6r3syuzhr3o">
            <GiftIcon className="mx-auto h-10 w-10 text-highlight" aria-hidden="true" data-id="element-170" data-mp="2h4ia20aael0i" />
            <h2 className="mt-3 font-display text-3xl font-bold text-highlight sm:text-5xl" data-id="element-171" data-mp="2c6qfszm66mt5">
              Y ADEMÁS, TE LLEVÁS 5 BONOS
            </h2>
          </header>
          <div className="mt-10 space-y-4" data-id="element-172" data-mp="fbkl4fjmscku">
            {bonuses.map(({
            number,
            title,
            detail,
            items,
            value
          }) => <article key={number} className="flex flex-col gap-4 rounded-2xl border border-highlight/20 bg-surface p-5 sm:flex-row sm:items-start sm:p-7" data-id="element-173" data-mp="347lfordpuct1">
                <span className="w-fit whitespace-nowrap rounded-lg bg-highlight/10 px-3 py-2 font-bold text-highlight" data-id="element-174" data-mp="2u95qwv25vfmp">
                  🎁 BONO {number}
                </span>
                <div className="flex-1" data-id="element-175" data-mp="2kiugqqrvwa7d">
                  <h3 className="font-bold" data-id="element-176" data-mp="2ki19lop0jiop">{title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-muted" data-id="element-177" data-mp="2p9jcwjeidvcu">
                    {detail}
                  </p>
                  <ul className="mt-3 space-y-1.5" data-id="element-178" data-mp="2bj7fq632h6eu">
                    {items.map(item => <li key={item} className="flex gap-2 text-sm leading-relaxed text-foreground-muted" data-id="element-179" data-mp="2ggzgzqplq4vp">
                        <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-highlight" aria-hidden="true" data-id="element-180" data-mp="21jgnyc5w55ig" />
                        {item}
                      </li>)}
                  </ul>
                </div>
                <div className="flex shrink-0 items-center gap-3" data-id="element-181" data-mp="1myb4q0xap3du">
                  <span className="text-xs font-semibold text-foreground-faint" data-id="element-182" data-mp="1ivxylbemz3gj">VALOR:</span>
                  <span className="text-sm text-foreground-faint line-through" data-id="element-183" data-mp="1wvfu09mfteyv">
                    {value}
                  </span>
                  <span className="rounded-full bg-primary-soft px-3 py-1 text-sm font-bold text-canvas" data-id="element-184" data-mp="1rvbasbu5a64y">
                    GRATIS
                  </span>
                </div>
              </article>)}
          </div>
          <div className="mt-8 rounded-2xl border border-highlight/30 bg-highlight/10 p-6 text-center" data-id="element-185" data-mp="21tqzy99m35bt">
            <p className="text-xs font-bold tracking-brand text-highlight" data-id="element-186" data-mp="2flffkmj2kbxj">
              VALOR TOTAL BONOS
            </p>
            <p className="mt-1 text-2xl font-bold text-foreground-subtle line-through" data-id="element-187" data-mp="2aoxa1kfx09k5">
              $52.000
            </p>
            <p className="mt-2 font-display text-xl font-bold text-highlight" data-id="element-188" data-mp="2kla5onv0sxhj">
              GRATIS con tu Kit Simplificación Integral™
            </p>
          </div>
        </div>
      </section>
    </>;
}